import { toPairs } from 'lodash/fp';

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "or": {"allowLocales": ["de", "es", "nl"], "hasCookie": true},
      }
    }
 */

export default (getChecker) => (featureName, checkers) => (locals) => {
  checkers = toPairs(checkers);

  return checkers.some(([checkerName, args]) =>
    getChecker(checkerName)(featureName, args)(locals),
  );
};
